/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LineMessage } from "./LineMessage";
export type CsvError = {
  details: Array<LineMessage>;
  kind: CsvError.kind;
} | {
  details: Array<string>;
  kind: CsvError.kind;
};
export namespace CsvError {
  export enum kind {
    LINE_ERRORS = "lineErrors",
  }
}
